import '../style.scss';
import { Toast } from 'views/mutual/toast';
import { PageStep } from '../hooks';
import { SendSMSTemplate } from 'views/templates/sendSMS';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { SearchSelect } from 'views/mutual/searchSelector';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { EntryConfirm } from 'views/templates/personalAccountOpen/entryConfirm';
import { EntryComplete } from 'views/templates/personalAccountOpen/entryComplete';
import { CheckInput } from 'views/templates/module/checkInput';
import { Caption } from 'views/mutual/caption';
import { AdvanceQuestion } from 'views/templates/personalAccountOpen/advanceQuestion';
import { SelectPersonalItem, useUpdatePersonalAccountPage } from './useUpdatePage';
import { CustomerInfo } from 'views/templates/personalAccountOpen/customerInfo';
import { UpdateSendMail } from 'views/templates/personalAccountOpen/updateSendMail';

type PersonalAccountInfoType = {
    pageStep : any,
    setPageStep: any,
    initislPageProps : any, 
    authPageProps : any,
    fpgPolicyProps : any, 
    fpgSecPolicyProps : any, 
    fpgTrustPolicyProps : any, 
    agreementProps : any, 
    toastProps : any, 
}
export const PersonalAccountInfo = (
    {
    pageStep,
    setPageStep,
    initislPageProps,
    authPageProps,
    fpgPolicyProps,
    fpgSecPolicyProps,
    fpgTrustPolicyProps,
    agreementProps,
    toastProps,
    } : PersonalAccountInfoType
) => {
    const updatePageProps = useUpdatePersonalAccountPage(pageStep, setPageStep);

  return (
    <div className="accountSetting">
      {pageStep === PageStep.PRE && (
        <div className="accountSetting_agreement">
          <Caption label="変更届" />
          <div className="accountSetting_agreement_text">
            <div>
              お客様には、お客様に関する登録情報が変更になった場合、変更届の提出をお願いしております。また、犯罪による収益の移転防止に関する法律に基づく取引時確認事項に変更が生じた場合、FPGオンライン取引・電子署名取引一般規約に基づき変更事項を届け出ていただきます。さらに、FPGグループ各社との契約上、お客様の情報が変更された場合に各社に届出を行う旨定められていることがあります。以下、お客様より、上記にて届出が必要な範囲の各社に対して、変更事項を届け出ていただきます。
            </div>
            <div>
            本システムを通じて登録情報の変更を届け出ていただきますと、本システムを運営する株式会社ＦＰＧが受領するとともに、同社以外に届出先がある場合には、お客様を代行して同社より届出先のグループ内他社にも届出事項を連絡いたしますのでご承知ください。これにより、日本型オペレーティング・リース事業以外の商品についても変更の届け出がなされ、お客様が、FPGグループ各社に個別に契約上の届出をしていただく必要はございません。なお、本変更届出に伴い、本人確認に関するお手続き等をお願いする場合がございますので、ご了承のほどお願いいたします。 
            </div>
            <div>
              なお、株式会社FPG及び届出を受けた各社においては、届出事項を、FPGオンライン取引・電子署名取引一般規約（及び個人情報については以下の各社のプライバシーポリシー）に従って利用させていただきます。
            </div>
          </div>
          <div className="accountSetting_agreement_check">
            <div>
              <CheckInput
                name="fpg_privacy_policy"
                label={
                  <>
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={process.env.REACT_APP_FPG_PRIVACY_POLICY_URL}
                      {...fpgPolicyProps}
                    >
                      株式会社FPG　個人情報の保護に関する公表事項
                    </a>
                  </>
                }
                {...fpgPolicyProps}
              />
              <CheckInput
                name="fpg_sec_privacy_policy"
                label={
                  <>
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={process.env.REACT_APP_FPG_SECURITIES_PRIVACY_POLICY_URL}
                      {...fpgSecPolicyProps}
                    >
                      株式会社FPG証券　個人情報の利用目的
                    </a>
                  </>
                }
                {...fpgSecPolicyProps}
              />
              <CheckInput
                name="fpg_trust_privacy_policy"
                label={
                  <>
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={process.env.REACT_APP_FPG_TRUST_PRIVACY_POLICY_URL}
                      {...fpgTrustPolicyProps}
                    >
                      株式会社ＦＰＧ信託　個人情報の保護に関する公表事項
                    </a>
                  </>
                }
                {...fpgTrustPolicyProps}
              />
            </div>
          </div>
          <div className="accountSetting_agreement_button">
            <Button
              label="各社のプライバシーポリシーに同意して、変更届を提出する"
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.large}
              {...agreementProps}
            />
          </div>
        </div>
      )}
      {pageStep === PageStep.INITIAL && (
        <div className="accountSetting_sms">
          <div className="accountSetting_sms_title">
            <Description
              labelColor={labelColor.gray}
              labelSize={labelSize.medium}
              label={`ご登録内容の照会/変更には2段階認証が必要です`}
            />
          </div>
          <Button
            type={ButtonType.Button}
            label="認証コードを送信"
            buttonFill={ButtonFill.primary}
            buttonSize={ButtonSize.medium}
            {...initislPageProps.sendSMSBtnProps}
          />
        </div>
      )}
      {pageStep === PageStep.AUTH && <SendSMSTemplate {...authPageProps} toastProps={toastProps} />}
      {pageStep === PageStep.QUESTION && (
        //法人と個人で出し分け
        <div className="accountSetting_form">
          <AdvanceQuestion {...updatePageProps.questionInfo} {...updatePageProps.templatePageProps} />
        </div>
      )}
      {pageStep === PageStep.UPDATE && (
        <form className={'accountSetting_form'}>
          <div className="accountSetting_selectWrapper">
            <div className="accountSetting_selectWrapper_select">              
              <SearchSelect {...updatePageProps.selectProps} />
            </div>
            <div className="accountSetting_selectWrapper_button">
              <Button
                type={ButtonType.Button}
                label="更新内容を確認する"
                buttonFill={ButtonFill.primary}
                buttonSize={ButtonSize.large}
                onClick={updatePageProps.executeConfirm}
              />
            </div>
          </div>
          <div className="accountSetting_form">
            {updatePageProps.selectProps.selectedOption === SelectPersonalItem.CustomerInfo && (
              <CustomerInfo {...updatePageProps.customerInfo} {...updatePageProps.templatePageProps} />
            )}
          </div>
        </form>
      )}
      {pageStep === PageStep.CONFIRM && <EntryConfirm {...updatePageProps.templatePageProps} isMailChanged = {updatePageProps.isMailChanged} />}
      {pageStep === PageStep.SENDMAIL && <UpdateSendMail {...updatePageProps.templatePageProps} />}
      {pageStep === PageStep.COMPLETE && <EntryComplete {...updatePageProps.templatePageProps} />}
      <Toast {...toastProps} />
    </div>
  );
};
